import React, { useState, useEffect, useLayoutEffect } from 'react';
import { Alert, ErrorScreen } from 'components/common';
import { useInventory, useUser, useList } from 'components/hooks';
import { ROUTES } from 'consts';
import { formatProjectItems } from 'helpers';
import withRequest from 'hoc/withRequest';
import { useHistory, withRouter } from 'react-router-dom';
import { InventorySchema } from 'schemas';
import { CircularProgress, Backdrop } from '@mui/material';
import InventoryFormDumb from './InventoryFormDumb';


const InventoryEditSmart = (props) => {
  const { match: { params } } = props;
  const { inventory, baseUrl } = params;
  const history = useHistory();
  const { cleanUpMessage, error, success, putInventory, getInventory, data, isLoaded } = useInventory();
  const companies = useList('companies');
  const [dataLoaded, setDataLoaded] = useState(false);

  const [defaultValues, setDefaultValues] = useState({
    name: '',
    description: '',
    additionalVariables: '',
    company: '',
    type: 'Form',
    fileType: 'ini',
    tags: [],
    hosts: [],
    hostGroups: [],
    childrenGroups: [],
  });

  useEffect(() => {
    if (!!success.put) {
      history.push(ROUTES.INVENTORY_LIST);
    } else if (!!success.get) {
      handleData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [success.get, success.put]);

  useLayoutEffect(() => {
    companies.getContentList({ query: {}});
    const query = { name: inventory }
    getInventory({ query });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleCloseAlert = () => cleanUpMessage();

  const handleEdit = (data) => {
    let hostGroups = [];
    let childrenGroups = [];

    if (data.hostGroups){
      hostGroups = data.hostGroups.map(g => {
        delete g.hostToShow;
        return g;
      });
    }

    if (data.childrenGroups) {
      childrenGroups = data.childrenGroups.map(c => {
        delete c.groupsToShow;
        return c;
      });
    }

    const body = {
      newname: data.name,
      name: inventory,
      description: data.description,
      additional_variables: data.additionalVariables,
      company: data.company,
      type: data.type,
      file_type: data.fileType,
      tags: data.type === "Form" ? data.tags : [],
      hosts: data.type === "Form" ? data.hosts : [],
      host_groups: data.type === "Form" ? hostGroups : [],
      children_groups: childrenGroups,
      fromEdit: true
    }
    putInventory({ body });
  };

  function handleData() {
    let groups = [];
    let children = [];

    if (data.host_groups) {
      groups = data.host_groups.map( g => ({
        ...g,
        hostToShow: g.hosts.map(host => host.label).join(',')
      }));
    }

    if (data.children_groups) {
      children = data.children_groups.map(child => ({
        ...child,
        groupsToShow: child.hostGroups.map(host => host.label).join(',')
      }));
    }

    const dataToSet = {
      name: data.name,
      description: data.description,
      additionalVariables: data.additional_variables,
      company: data.company,
      tags: data.tags,
      type: data.type || 'Form',
      fileType: data.file_type || 'ini',
      hosts: data.hosts,
      hostGroups: groups,
      childrenGroups: children,
    }
    setDefaultValues({...defaultValues, ...dataToSet});
    setDataLoaded(true);
  };

  return (
    <>
      { isLoaded.get ?
        (
          <Backdrop
            invisible
            sx={{ zIndex: (theme) => theme.zIndex.drawer - 1 }}
            open={true}
          >
            <CircularProgress color="primary" />
          </Backdrop>
        ): error.get ?
        (
          <ErrorScreen />
        ): (companies.content && dataLoaded) ?
        (
          <InventoryFormDumb
            defaultValues={defaultValues}
            handleOnSubmit={handleEdit}
            companies={companies.content.map((i) => ({ value: i.company_id, label: i.name }))}
            isEdit={true}
          />
        )
        :(
          <></>
        )
      }
      <Alert severity="error" handleClose={handleCloseAlert} open={error.put} message="common.errors.general.title" />
    </>
  );
};

export default withRequest(withRouter(InventoryEditSmart));
